///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const AnalyticsIcon = ({
  height,
  title = messages.analytics.defaultMessage,
  width
}) => (
  <svg
    aria-labelledby="analytics-icon"
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="analytics-icon">{title}</title>
    <mask
      id="analytics"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width={width}
      height={height}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.778 0h12.444C15.2 0 16 .8 16 1.778v12.444C16 15.2 15.2 16 14.222 16H1.778C.8 16 0 15.2 0 14.222V1.778C0 .8.8 0 1.778 0zm1.777 12.444h1.778V6.222H3.555v6.222zm5.334 0H7.111V3.556H8.89v8.888zm1.778 0h1.777V8.89h-1.777v3.555z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#analytics)">
      <path fill="#fff" d="M0 0h16v16H0z" />
    </g>
  </svg>
);

export default AnalyticsIcon;
